/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReferralPaymentStatus = {
    AwaitingDeliverableCompletion: 'AWAITING_DELIVERABLE_COMPLETION',
    AwaitingInvoiceGeneration: 'AWAITING_INVOICE_GENERATION',
    AwaitingCompliance: 'AWAITING_COMPLIANCE',
    AwaitingPayment: 'AWAITING_PAYMENT',
    PaymentToBeRetried: 'PAYMENT_TO_BE_RETRIED',
    Done: 'DONE'
} as const;
export type ReferralPaymentStatus = typeof ReferralPaymentStatus[keyof typeof ReferralPaymentStatus];


export function instanceOfReferralPaymentStatus(value: any): boolean {
    for (const key in ReferralPaymentStatus) {
        if (Object.prototype.hasOwnProperty.call(ReferralPaymentStatus, key)) {
            // @ts-ignore
            if (ReferralPaymentStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReferralPaymentStatusFromJSON(json: any): ReferralPaymentStatus {
    return ReferralPaymentStatusFromJSONTyped(json, false);
}

export function ReferralPaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralPaymentStatus {
    return json as ReferralPaymentStatus;
}

export function ReferralPaymentStatusToJSON(value?: ReferralPaymentStatus | null): any {
    return value as any;
}

